"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _BaseRender = /*#__PURE__*/ _interop_require_default(require("../../BaseRender"));
const _mapDefaultDisplayValue = /*#__PURE__*/ _interop_require_default(require("~/helpers/mapDefaultDisplayValue"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let BaseModelXcMeta = class BaseModelXcMeta extends _BaseRender.default {
    getXcColumnsObject(args) {
        const columnsArr = [];
        for (const column of args.columns){
            var _this_ctx_belongsTo, _this_ctx, _this_ctx_oldMeta_columns, _this_ctx_oldMeta, _this_ctx1;
            if ((_this_ctx = this.ctx) == null ? void 0 : (_this_ctx_belongsTo = _this_ctx.belongsTo) == null ? void 0 : _this_ctx_belongsTo.find((c)=>c.cn === column.cn)) column.uidt = _nocodbsdk.UITypes.ForeignKey;
            const columnObj = _extends({
                validate: {
                    func: [],
                    args: [],
                    msg: []
                },
                column_name: column.cn || column.column_name,
                title: column._cn || column.cn || column.column_name || column.title,
                type: this._getAbstractType(column),
                dt: column.dt,
                uidt: column.uidt || this.getUIDataType(column),
                uip: column.uip,
                uicn: column.uicn
            }, column);
            if (column.rqd) {
                columnObj.rqd = column.rqd;
            }
            if (column.cdf) {
                columnObj.default = column.cdf;
                columnObj.columnDefault = column.cdf;
            }
            if (column.un) {
                columnObj.un = column.un;
            }
            if (column.pk) {
                columnObj.pk = column.pk;
            }
            if (column.ai) {
                columnObj.ai = column.ai;
            }
            if (column.dtxp) {
                columnObj.dtxp = column.dtxp;
            }
            if (column.dtxs) {
                columnObj.dtxs = column.dtxs;
            }
            const oldColMeta = (_this_ctx1 = this.ctx) == null ? void 0 : (_this_ctx_oldMeta = _this_ctx1.oldMeta) == null ? void 0 : (_this_ctx_oldMeta_columns = _this_ctx_oldMeta.columns) == null ? void 0 : _this_ctx_oldMeta_columns.find((c)=>{
                return columnObj.cn == c.cn && columnObj.type == c.type;
            });
            if (oldColMeta) {
                columnObj._cn = oldColMeta._cn || columnObj._cn;
                columnObj.uidt = oldColMeta.uidt;
                if ((columnObj.uidt === _nocodbsdk.UITypes.MultiSelect || columnObj.uidt === _nocodbsdk.UITypes.SingleSelect) && columnObj.dt !== 'set' && columnObj.dt !== 'enum') {
                    columnObj.dtxp = columnObj.dtxp || oldColMeta.dtxp;
                }
            }
            columnsArr.push(columnObj);
        }
        this.mapDefaultDisplayValue(columnsArr);
        return columnsArr;
    }
    renderXcHasMany(args) {
        return JSON.stringify(args.hasMany);
    }
    renderXcBelongsTo(args) {
        return JSON.stringify(args.belongsTo);
    }
    getObject() {
        return {
            tn: this.ctx.tn,
            _tn: this.ctx._tn,
            columns: this.getXcColumnsObject(this.ctx),
            pks: [],
            hasMany: this.ctx.hasMany,
            belongsTo: this.ctx.belongsTo,
            db_type: this.ctx.db_type,
            type: this.ctx.type,
            v: this.getVirtualColumns()
        };
    }
    getVirtualColumns() {
        var _this_ctx_oldMeta, _this_ctx;
        // todo: handle duplicate relation
        const virtualColumns = [
            ...(this.ctx.hasMany || []).map((hm)=>{
                return {
                    uidt: _nocodbsdk.UITypes.LinkToAnotherRecord,
                    type: 'hm',
                    hm,
                    _cn: `${hm._tn}List`
                };
            }),
            ...(this.ctx.belongsTo || []).map((bt)=>({
                    uidt: _nocodbsdk.UITypes.LinkToAnotherRecord,
                    type: 'bt',
                    bt,
                    _cn: `${bt._rtn}Read`
                }))
        ];
        const oldVirtualCols = ((_this_ctx = this.ctx) == null ? void 0 : (_this_ctx_oldMeta = _this_ctx.oldMeta) == null ? void 0 : _this_ctx_oldMeta.v) || [];
        for (const oldVCol of oldVirtualCols){
            if (oldVCol.lk || oldVCol.rl || oldVCol.formula) virtualColumns.push(oldVCol);
        }
        return virtualColumns;
    }
    mapDefaultDisplayValue(columnsArr) {
        (0, _mapDefaultDisplayValue.default)(columnsArr);
    }
    /**
   *
   * @param args
   * @param args.columns
   * @param args.relations
   * @returns {string}
   * @private
   */ renderXcColumns(args) {
        let str = '[\r\n';
        for(let i = 0; i < args.columns.length; ++i){
            str += `{\r\n`;
            str += `cn: '${args.columns[i].cn}',\r\n`;
            str += `type: '${this._getAbstractType(args.columns[i])}',\r\n`;
            str += `dt: '${args.columns[i].dt}',\r\n`;
            if (args.columns[i].rqd) str += `rqd: ${args.columns[i].rqd},\r\n`;
            if (args.columns[i].cdf) {
                str += `default: "${args.columns[i].cdf}",\r\n`;
                str += `columnDefault: "${args.columns[i].cdf}",\r\n`;
            }
            if (args.columns[i].un) str += `un: ${args.columns[i].un},\r\n`;
            if (args.columns[i].pk) str += `pk: ${args.columns[i].pk},\r\n`;
            if (args.columns[i].ai) str += `ai: ${args.columns[i].ai},\r\n`;
            if (args.columns[i].dtxp) str += `dtxp: "${args.columns[i].dtxp}",\r\n`;
            if (args.columns[i].dtxs) str += `dtxs: ${args.columns[i].dtxs},\r\n`;
            str += `validate: {
                func: [],
                args: [],
                msg: []
              },`;
            str += `},\r\n`;
        }
        str += ']\r\n';
        return str;
    }
};
const _default = BaseModelXcMeta;
